export const WebMailHostPlaceHolder = '__wmail_prefix__';
export const CommonMailHostPlaceHolder = '__prefix__';
export const SubAccountExpired = 'subAccountExpired';
export const getSidRegexp = () => /sid=[^&]+/i;
export const MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT = 'LatestContact';
export const MAIL_PLUS_CUSTOMER_GROUP_MONITOR = 'Monitor';
export const MAIL_PLUS_CUSTOMER_GROUP_FAVORITE = 'Favorite';
